module.exports = __webpack_public_path__ + "img/canceled.37377de9.svg";